import React from 'react'
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { useDispatch } from 'react-redux';
import { deleteCollection } from '../../../../features/collections/collectionSlice';

import {
    blank_box
} from '../../../../../assets/index';

const PostCard = ({resource}) => {

    const dispatch = useDispatch();
    // console.log(resource);
  return (
    <LinkToDetails href={`/resource/${resource?.resourceId?.resourceNlnCode}`} target='_blank' >
        <BoxContainer>
            
            <ImageContainer src={resource?.resourceId?.resourceImage} />
            <TextContainer>
                <h5>
                {resource?.resourceId?.resourceTitle}
                </h5>
                <small>
                {resource?.resourceId?.resourceAuthors} 
                </small>
                <div 
                    onClick={ (e) => dispatch(deleteCollection(resource.resourceCollectionItemId)) }>🗑️
                </div>
            </TextContainer>
            {/* resourceCollectionItemId */}
            
        </BoxContainer>
    </LinkToDetails>
  )
};

export const BoxContainer = styled.div`
    width: 236px;
    display: flex;
    padding-top: 10px;
    flex-direction: column;
    cursor: pointer;

    @media screen and (max-width: 600px){
        width: 300px;
    }
`

export const ImageContainer = styled.img`
    width: inherit;
    height: 254px;
    object-fit: fill;
    border-radius: 4px 4px 0px 0px;

    @media screen and (max-width: 600px){
        width: 300px;
    }

    :hover{
        opacity: 0.8;
        transition: 0.5s;
    }
`
const LinkToDetails = styled.a`
    text-decoration: none;
    color: #000;
`

export const TextContainer =  styled.div`
    padding: 10px 20px;
    width: 100%;
    text-align: left;
    box-shadow: 0px 4px 4px rgba(255, 255, 255, 0.25), 0px 4px 4px rgba(0, 0, 0, 0.15);
    border-radius: 0 0 4px 4px;
    position: relative;

    & > h5{
        width: 100%;
    }

    & > div{
        text-align: right;
        width: fit-content;
        position: absolute;
        right: 5%;
        bottom: 10%;
        cursor: pointer;
    }
`


export {PostCard}